const STORAGE_KEY = 'concreto_tec.session';

// Padroniza a resposta de login em { token, user: { role, idCliente, nome, email } }.
function normalizeSession(dadosDoBackend) {
  if (!dadosDoBackend) {
    return null;
  }

  const user = dadosDoBackend.user || {
    role: dadosDoBackend.role || 'admin',
    idCliente: dadosDoBackend.id_cliente || dadosDoBackend.idCliente || null,
    nome: dadosDoBackend.nome || dadosDoBackend.name || null,
    email: dadosDoBackend.email || null,
  };

  return {
    token: dadosDoBackend.token || null,
    user,
  };
}

// Persiste a sessão no localStorage (token separado + objeto da sessão).
export const saveSession = (dadosDoBackend) => {
  const session = normalizeSession(dadosDoBackend);

  if (!session) {
    return;
  }

  if (session.token) {
    localStorage.setItem('token', session.token);
  }

  localStorage.setItem(STORAGE_KEY, JSON.stringify(session));
};

// Remove token e sessão do localStorage (logout).
export function clearSession() {
  localStorage.removeItem('token');
  localStorage.removeItem(STORAGE_KEY);
}

// Lê a sessão do localStorage (ou null se ausente/corrompida).
export function getSession() {
  const raw = localStorage.getItem(STORAGE_KEY);
  if (!raw) {
    return null;
  }
  try {
    return JSON.parse(raw);
  } catch (error) {
    return null;
  }
}

// Papel do usuário logado (ou null).
export function getSessionRole() {
  const session = getSession();
  return session?.user?.role || session?.role || null;
}

// Id do cliente associado à sessão (ou null).
export function getSessionClientId() {
  const session = getSession();
  return session?.user?.idCliente || session?.user?.id_cliente || session?.idCliente || session?.id_cliente || null;
}
